/**
 * Function to transform integer cents into
 * two decimal dollar values
 *
 * @param {number|string} amount - amount to transform to dollars
 * @returns {number} dollars
 */
function toDollars(amount = 0) {
  return Math.round(amount) / 100;
}

export default toDollars;
